import { service } from '@maia/cart';

export function getCancellationQuestionsOptions({
  customerGuid,
  cancellationGuid,
  insuranceGuid,
}: {
  customerGuid: string;
  cancellationGuid: string;
  insuranceGuid: string;
}) {
  return {
    queryKey: ['cancellation', cancellationGuid],
    queryFn: () =>
      service.getCancellationQuestions({
        insuranceGuid,
        customerGuid,
        cancellationGuid,
      }),
  };
}
